import { makeStyles } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()({
  search: { margin: '12px 0 0' },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    margin: '12px 0'
  },
  count: { marginLeft: 'auto', color: '#6B7280' },
  // Outer element scrolls; the inner multi-column element grows naturally so
  // markets flow A→Z down each column.
  list: {
    maxHeight: 360,
    overflowY: 'auto'
  },
  columns: {
    columnCount: 3,
    columnGap: 24
  },
  // keep a market (checkbox + its clickable label) together within its column
  row: {
    breakInside: 'avoid',
    paddingBlock: 2
  },
  rowLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6
  },
  flag: { fontSize: 16, lineHeight: 1 }
})

export default useStyles
